var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('Downloads',{attrs:{"dates":this.$store.state.calendar.dates,"selected-domains":this.$store.state.auth.selectedDomains}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }